import compact from "lodash/compact";
import flatMap from "lodash/flatMap";
import map from "lodash/map";
import React from "react";
import { v4 as uuid } from "uuid";
import getGraphNodeSources from "../nodeOrEdgeSourceDataHandling/getGraphNodeSources";
import buildCopyCallback from "./buildCopyCallback";
import buildDeleteCallback from "./buildDeleteCallback";
import locale from "./buildItems.locale";
import buildPasteCallback from "./buildPasteCallback";
export default async (graphComponentRef, cursorOnEmptySpace, documentId, calculateMethodsSubMenu, onPasteToDocumentGraphData, onSetHasPasteData, onOpenTableDetails) => {
    if (!graphComponentRef.current)
        return undefined;
    const { selectedNodes } = graphComponentRef.current.selection;
    if (selectedNodes.size === 0 || cursorOnEmptySpace) {
        const pasteCallback = buildPasteCallback(graphComponentRef, documentId, onPasteToDocumentGraphData);
        return pasteCallback
            ? [
                {
                    icon: "icon-document-clone font-h5 text-muted",
                    text: locale.PASTE,
                    onClick: pasteCallback
                }
            ]
            : undefined;
    }
    const hasSelected = Boolean(selectedNodes.size);
    const copyCallback = hasSelected
        ? buildCopyCallback(graphComponentRef, documentId, onSetHasPasteData)
        : undefined;
    const deleteCallback = hasSelected ? buildDeleteCallback(graphComponentRef) : undefined;
    const nodeIds = flatMap(selectedNodes.toArray(), n => map(getGraphNodeSources(n), "NodeId"));
    const openTableItem = onOpenTableDetails && nodeIds.length > 1
        ? {
            icon: "icon-grid font-h5 text-muted",
            text: locale.OPEN_TABLE,
            onClick: () => {
                onOpenTableDetails(documentId, nodeIds);
            }
        }
        : undefined;
    const methodsPanelRef = React.createRef();
    const methodsSubMenu = calculateMethodsSubMenu(uuid(), methodsPanelRef);
    return compact([
        openTableItem,
        openTableItem && {
            divider: true
        },
        methodsSubMenu && {
            icon: "icon-folder-connection font-h5 text-muted",
            text: locale.METHODS,
            subMenu: methodsSubMenu,
            onSubMenuHidden: () => {
                var _a;
                (_a = methodsPanelRef.current) === null || _a === void 0 ? void 0 : _a.hideConfirmations();
            }
        },
        methodsSubMenu && {
            divider: true
        },
        copyCallback && {
            icon: "icon-document-clone font-h5 text-muted",
            text: locale.COPY,
            onClick: copyCallback
        },
        deleteCallback && {
            icon: "icon-trash font-h5 text-red",
            textClassName: "text-red",
            text: locale.DELETE,
            onClick: deleteCallback
        }
    ]);
};
